import { render, staticRenderFns } from "./cloudHome.vue?vue&type=template&id=5ffd52e4&scoped=true&"
import script from "./cloudHome.vue?vue&type=script&lang=js&"
export * from "./cloudHome.vue?vue&type=script&lang=js&"
import style0 from "./cloudHome.vue?vue&type=style&index=0&id=5ffd52e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd52e4",
  null
  
)

export default component.exports